import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InitialStateService {

  public loginComponentInitialized: boolean = false;
  public destinyUserResetRequestReason: string;
  public skipGuestLoginPrompt: boolean = false;

}